let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4hJCH")).then(() => parcelRequire('8JMZ0'));